export function Button({
  children,
  onClick,
  type = "button",
  variant = "default",
  size = "default",
  disabled = false,
  describedBy,
  className,
  ...rest
}: {
  children: React.ReactNode;
  onClick?: () => void;
  type?: "button" | "submit";
  /** `destructive` is the danger outline; `danger` is the solid confirm inside a destructive dialog (§3). */
  variant?: "default" | "primary" | "destructive" | "danger";
  /** `compact` is the 36 px height used in table rows, the top bar and segmented tabs (§3). */
  size?: "default" | "compact";
  disabled?: boolean;
  describedBy?: string;
  className?: string;
  title?: string;
} & { "data-testid"?: string; "aria-label"?: string }): JSX.Element {
  const variantClass = variant === "default" ? "" : ` button--${variant}`;
  const sizeClass = size === "default" ? "" : ` button--${size}`;
  const extra = className === undefined ? "" : ` ${className}`;
  return (
    <button
      type={type}
      className={`button${variantClass}${sizeClass}${extra}`}
      onClick={onClick}
      disabled={disabled}
      aria-describedby={describedBy}
      {...rest}
    >
      {children}
    </button>
  );
}
